import React from "react";
import { navigate } from "gatsby";

import {
    content,
    profileShortcut,
    profileShortcutText,
    profileShortcutButton,
} from "./survey-session-view.module.scss";
import { mainGrid } from "../../../styles/grid.module.scss";

import Section from "../../../components/molecules/section";
import SurveySession from "../../../components/organisms/survey/survey-session";

const STARTER_PROFILE_EDIT_PATH = "/konto/profil-startowy/?edycja=1";

interface ISurveySessionView {
    surveySessionId?: number | string;
}

export default function SurveySessionView({ surveySessionId }: ISurveySessionView) {
    return (
        <div className={`${mainGrid} ${content}`}>
            <Section>
                <div className={profileShortcut}>
                    <div className={profileShortcutText}>
                        <strong>Profil startowy</strong>
                        <span>Zaktualizuj styl, kolory, rozmiary i budżet w czterech krótkich krokach.</span>
                    </div>
                    <button
                        type="button"
                        className={profileShortcutButton}
                        onClick={() => navigate(STARTER_PROFILE_EDIT_PATH)}
                    >
                        Edytuj profil startowy
                    </button>
                </div>
                <SurveySession sessionId={surveySessionId} />
            </Section>
        </div>
    );
}
